<template>
  <div class="member-buy-page introduce-container">

    <div class="header-wrap">
      <h1 class="title ">开通潮国VIP会员 尊享每日独家设计</h1>
      <div class="identify-box ">
        <div class="identify-item">
          <i class="icon_shang"/>
          畅享正版海量下载
        </div>
        <div class="identify-item">
          <i class="icon_zuan"/>
          专属VIP身份标识
        </div>
      </div>
    </div>

    <VipFixedHeader :scroll-top="scrollTop" @buy="navigatorToPay"/>
    <VipCardGroup @buy="navigatorToPay"/>
    <Privilege/>
    <div ref="AuthorizedScope">
      <AuthorizedScope @buy="navigatorToPay"/>
    </div>

    <div ref="VipCompare">
      <VipCompare/>
    </div>

    <NewYearDialog class="NewYearDialogWrap"
                   ref="NewYearDialog"
                   @close="closeNewYearDialog"
    />

  </div>
</template>

<script>

/* 组件 */
import {MemberPackage} from '~/components/member'
import {info} from '~/components/member/common/module'
import {mapGetters} from "vuex";
import {tagStat} from "../../api/stat";
import {fnFlowStatistics, fnLayout, fnLocalStorage, fnLogin, fnPay} from "@/fn";
import memberExtend from "~/components/member/common/member-extend";
import NewYearDialog from "@/components/act/new-year/dialog2"

import {privilegeList} from "@/components/introduce/common/module";
import {
  VipFixedHeader,
  Privilege,
  VipCardGroup,
  AuthorizedScope,
  VipCompare
} from "~/components/introduce";
import {PAY} from "@/constant/PATH";
import {tag} from "@/utils/statUtil";
import {getNewYearCoupon} from "@/api/act/newYear";
import {VIP_MANAGE} from "@/constant/VIP_MANAGE";

export default {
  layout: "header-nav",
  name: "LicenseVip",
  mixins: [memberExtend],
  components: {
    MemberPackage,
    VipFixedHeader,
    Privilege,
    VipCardGroup,
    AuthorizedScope,
    VipCompare,
    NewYearDialog
  },
  created() {
    const stat = '充值::图片:onload'
    tagStat({stat})
  },
  head() {
    return {
      title: 'VIP会员服务_全站高质量可下载资源_潮国创意'
    }
  },
  data() {
    return {
      info,
      privilegeList,
      scrollTop: 0,
      VIP_MANAGE
    }
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'vipIsPerson', 'vipIsBusiness'])
  },
  watch: {
    isLogin: {
      handler(n, o) {
        if (n && n == true) {
          this.init();
        }
      },
    }
  },

  async mounted() {
    this.init();
  },

  methods: {
    async getNewYearCoupon() {
      if (fnLogin.checkLogin()) {
        let res = await getNewYearCoupon()
        this.$refs.NewYearDialog.isShow = true;
      }
    },
    closeNewYearDialog() {
      this.$refs.NewYearDialog.isShow = false;
    },
    init() {
      fnLayout.setFooterBgColor();
      this.handleScroll()
      window.addEventListener("scroll", this.handleScroll);
      fnFlowStatistics.pageFlow('personVip')
      // this.getNewYearCoupon();
    },
    handleScroll() {
      this.scrollTop = this.$refs.AuthorizedScope.getBoundingClientRect().top;
    },
    navigatorToPay(vo) {
      if (fnLogin.checkLogin()) {
        tag('充值:VIP介绍页:图片')

        let path = `${PAY}/${vo.ID}`
        window.open(path, '_blank')
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", 1);
      }

    }
  }
}
</script>

<style lang="scss" scoped>
@import "index";

.introduce-container {
  /deep/ .inner_center {
    width: 1200px !important;
  }

  position: relative;


}


</style>
